import { useAuth } from "@/context/AuthContext";
import { setWorkspace } from "@/lib/workspace";
import AvidaMark from "@/components/AvidaMark";
import { HeartHandshake, UserPlus, ArrowRight } from "lucide-react";

export default function ChooserPage() {
  const { user } = useAuth();

  const pick = (w) => {
    setWorkspace(w);
    const dest = user?.role === "field_agent" ? "/field" : user?.role === "staff" ? "/my-day" : "/";
    window.location.assign(dest);
  };

  const Card = ({ w, title, sub, Icon, testId }) => (
    <button
      data-testid={testId}
      onClick={() => pick(w)}
      className="group relative bg-white rounded-xl border border-[#15233B]/10 shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 p-8 text-left w-full max-w-sm overflow-hidden"
    >
      <span className="absolute top-0 left-0 right-0 h-1.5 bg-[#FFCB05]" />
      <div className="h-12 w-12 rounded-lg bg-[#15233B] grid place-items-center mb-4">
        <Icon className="h-6 w-6 text-[#FFCB05]" />
      </div>
      <div className="text-xl font-extrabold tracking-tight text-[#15233B]">{title}</div>
      <div className="text-sm text-[#15233B]/60 mt-1.5">{sub}</div>
      <div className="mt-5 flex items-center gap-1.5 text-xs font-extrabold text-[#1E73C9] group-hover:gap-3 transition-all">
        Open workspace <ArrowRight className="h-3.5 w-3.5" />
      </div>
    </button>
  );

  return (
    <div data-testid="workspace-chooser" className="min-h-screen bg-[#F6F3EC] flex flex-col items-center justify-center px-4">
      <AvidaMark size="lg" withWordmark={false} className="mb-3" />
      <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#15233B]/50 mb-1">Avida Lead Manager</div>
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-[#15233B] mb-8">Where are you working today?</h1>
      <div className="flex flex-col sm:flex-row gap-5 w-full max-w-3xl justify-center">
        <Card w="intake" title="Client Intake" sub="The 16-stage client pipeline — leads, authorizations and starts of care." Icon={HeartHandshake} testId="choose-clients" />
        <Card w="recruiting" title="Recruiting" sub="The caregiver hiring pipeline — applicants, interviews, background checks and onboarding." Icon={UserPlus} testId="choose-recruiting" />
      </div>
      <p className="text-[11px] text-[#15233B]/45 mt-8">You can switch anytime from the toggle in the header.</p>
    </div>
  );
}
